import React from 'react';
import AppFooter from '../AppFooter';
import AppHeader from '../AppHeader';
import Sticky, { StickyHorizontal } from '@gik/ui/Sticky';
import bemBlock from '@gik/core/utils/bemBlock';
import useMvcFullStory from './useMvcFullStory';
import { useUserStore } from '@gik/core/store/UserStore';
import { JITRequirement, useJIT } from '@gik/ui';
import useMixPanel from '@gik/core/hooks/useMixPanel';

interface AppLayoutProps {
  hideHeader?: boolean;
  hideFooter?: boolean;
}

const blockName = 'app-layout';

// declare requirements outside of function so that array is not recreated on each rerender
const collectUserFirstNameRequirements: JITRequirement[] = ['user-firstName'];

export default function AppLayout({
  children,
  hideHeader = false,
  hideFooter = false,
}: React.PropsWithChildren<AppLayoutProps>) {
  const bem = bemBlock(blockName);
  const userStore = useUserStore();

  // TODO: after SPA migration move this to the root of the application
  useMvcFullStory(userStore.id);

  // TODO: after SPA migration move this to the root of the application
  useMixPanel();

  // TODO: after SPA migration move this to the root of the application
  const collectUserFirstName = useJIT(collectUserFirstNameRequirements);

  React.useEffect(() => {
    collectUserFirstName?.();
  }, [collectUserFirstName]);

  return (
    <div className={bem()}>
      {!hideHeader && (
        <Sticky className="app-header-sticky">
          <StickyHorizontal>
            <AppHeader />
          </StickyHorizontal>
        </Sticky>
      )}
      <main>{children}</main>
      {!hideFooter && (
        <StickyHorizontal>
          <AppFooter />
        </StickyHorizontal>
      )}
    </div>
  );
}
